export const getTimeStamp = () => new Date()
    .toISOString()
    .replace('T', ' ')
    .split('.')[0];
